import { get, patch } from "../../api/api";
import { IRespostaFuncao } from 'src/integracoes/modelos/funcoes';

// Listar parametros globais
export const listarParametrosGlobais = async () => {
  return await get<IRespostaFuncao<any>>(`/parametros-globais`);
};

// Atualizar parametros globais
export const atualizarParametrosGlobais = async (
  id: string,
  payload: any,
): Promise<IRespostaFuncao<any>> => {
  return await patch<IRespostaFuncao<any>>(
    `/parametros-globais/atualiza-parametros-globais?id=${id}`,
    payload
  );
};